/**
 * Avalara © 2019
 * file: engines/opus_ui/src/containers/EnginesContainer.jsx
 */

import React from 'react';
import EngineItem from './EngineItem';

import './EnginesContainer.css';

export default function EnginesContainer(props) {
  return (
    <div className="engines">
      <div className="statusHolder">
        <h1 className="labelTitle">Status</h1>
      </div>
      <EngineItem name="Account" />
      <EngineItem name="Auth" />
      <EngineItem name="Billing" />
      <EngineItem name="Bookings" />
      <EngineItem name="Business Activity" />
      <EngineItem name="CPQ" />
      <EngineItem name="Customer" />
      <EngineItem name="Default" />
      <EngineItem name="Delivery" />
      <EngineItem name="Event Notifications" />
      <EngineItem name="Legal" />
      <EngineItem name="Marketing" />
      <EngineItem name="Product" />
      <EngineItem name="Provisioning" />
      <EngineItem name="Usage" />
    </div>
  );
}
